<div class="process-box">
  <div class="process-number">PROCESO: {{ (simulation.identifier) }}
    <button mat-icon-button [matMenuTriggerFor]="menu" class="more-info">
      <mat-icon
        class="icon-arrow"
        aria-hidden="false"
        aria-label="more-info">
        expand_more
      </mat-icon>
    </button>
  </div>
  <div class="process-info">
    <h2>{{ (simulation.name.length > 30 ? simulation.name.substr(0, 30) + '...' : simulation.name) | uppercase }}</h2>
    <p><strong>MATERIA:</strong> {{ (simulation.subject.length > 30 ? simulation.subject.substr(0, 30) + '...' : simulation.subject) | uppercase }}</p>
    <p *ngIf="simulation.audienceDate"><strong>DIA AUDENCIA:</strong> {{ simulation.audienceDate | date: 'dd/MM/yyyy' }}</p>
    <p *ngIf="simulation.audienceJuicioDate"><strong>DIA JUICIO:</strong> {{ simulation.audienceJuicioDate | date: 'dd/MM/yyyy' }}</p>
  </div>

  <button class="ver-mas-button"(click)="abrirProceso(simulation.identifier)">
    Ingresar
  </button>

</div>
    <mat-menu #menu="matMenu" class="bg-919191a">
        <div class="panel-info">
            <h3>Participantes:</h3>
            <ul>
                <li><b>Ab. Demandante: </b><br>
                    {{simulation.ab_demandante.join(', ')}} </li>
                <li><b>Ab. Defensor: </b><br>
                    {{simulation.ab_defensor.join(', ')}} </li>
                <li><b>Juez: </b><br>
                    {{simulation.juez}} </li>
                <li><b>Secretario: </b><br>
                    {{simulation.secretario}} </li>
            </ul>
        </div>
    </mat-menu>
